import { __decorate, __metadata } from "tslib";
import moment from 'moment';
import { Component } from 'decorators';
let NotificationWeblinkComponent = class NotificationWeblinkComponent {
    constructor() { }
    $onChanges(changesObj) {
        const { notification } = changesObj;
        if (notification.currentValue) {
            this.date = this.getDate(this.notification.date);
        }
    }
    getDate(notificationDate) {
        const today = moment().startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayEnd = moment().subtract(1, 'days').endOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        const yesterdayStart = moment().subtract(1, 'days').startOf('day').format('YYYY-MM-DDTHH:mm:ss.SSS');
        if (notificationDate >= today) {
            return `Hoje - ${moment(notificationDate).format('HH:mm')}`;
        }
        if (notificationDate < yesterdayEnd && notificationDate > yesterdayStart) {
            return `Ontem - ${moment(notificationDate).format('HH:mm')}`;
        }
        return `${moment(notificationDate).format('DD/MM/YYYY')} - ${moment(notificationDate).format('HH:mm')}`;
    }
};
NotificationWeblinkComponent = __decorate([
    Component({
        template: `
    <div ng-if="$ctrl.notification.status == 'received'">
        <a href="{{$ctrl.notification.content.uri}}" class="bp-lh-simple" target="$ctrl.notification.content.target">
            <div class="notification-title b" ng-bind-html="$ctrl.notification.content.title">
            </div>
            <bds-typo data-test="typoTextNotificationTest" class="color-neutral-dark-city" bold="bold" variant="fs-16" tag="p">
                {{$ctrl.notification.content.text}}
            </bds-typo>
        </a>
        <bds-typo data-test="typoDateNotificationTest" class="color-neutral-dark-city" bold="bold" variant="fs-10" tag="p">
            {{$ctrl.date}}
        </bds-typo>
    </div>
    <div ng-if="$ctrl.notification.status != 'received'">
        <a href="{{$ctrl.notification.content.uri}}" class="bp-lh-simple" target="$ctrl.notification.content.target">
            <div class="notification-title" ng-bind-html="$ctrl.notification.content.title">
            </div>
            <bds-typo data-test="typoTextNotificationTest" class="color-neutral-dark-city" variant="fs-16" tag="p">
                {{$ctrl.notification.content.text}}
            </bds-typo>
        </a>
        <bds-typo data-test="typoDateNotificationTest" class="color-neutral-dark-city" variant="fs-10" tag="p">
            {{$ctrl.date}} {{ 'notificationsCenter.received' | translate}}
        </bds-typo>
    </div>
    `,
        bindings: {
            notification: '<?',
        },
    }),
    __metadata("design:paramtypes", [])
], NotificationWeblinkComponent);
export { NotificationWeblinkComponent };
